import { flushSync } from 'react-dom';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/**
 * Esegue `update` (di solito un navigate) dentro una View Transition nativa, così
 * gli elementi con lo stesso `view-transition-name` "volano" dalla lista al
 * dettaglio. Progressive enhancement: senza supporto o con reduced-motion,
 * esegue subito senza transizione.
 *
 * Mentre la VT è attiva mettiamo `html.vt-active` per disattivare il route-fade
 * (altrimenti le due animazioni si sovrappongono).
 */
export function withViewTransition(update: () => void) {
  const doc = document as Document & { startViewTransition?: (cb: () => void) => { finished: Promise<unknown> } };
  if (!doc.startViewTransition || prefersReducedMotion()) {
    update();
    return;
  }
  document.documentElement.classList.add('vt-active');
  const transition = doc.startViewTransition(() => { flushSync(update); });
  transition.finished.finally(() => document.documentElement.classList.remove('vt-active'));
}
